import { makeStyles } from '@material-ui/styles'

export const drawerWidth = 250
export const collapsedDrawerWidth = theme => theme.spacing(7) + 1

const useStyles = makeStyles(theme => ({
  filler: {
    flexGrow: 1,
  },
  brandSwitcherContainer: {
    display: 'flex',
    width: `${drawerWidth - 35}px`, // this -35 was originally -24 -11
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  brandSwitcherButton: {
    minWidth: 'fit-content',
    padding: 0,
    width: '40px',
    height: '40px',
  },
  appBar: ({ assumedUser }) => ({
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'white',
    boxShadow: 'none',
    borderBottom: '1px solid #E0E0E0',
    borderRadius: 0,
    marginTop: assumedUser ? '30px' : 'unset',
    [theme.breakpoints.only('xs')]: {
      marginTop: assumedUser ? '70px' : 'unset',
    },
  }),
  toolbar: {
    justifyContent: 'space-between',
  },
  toolbarCollapsibleSidebar: {
    paddingLeft: 0,
  },
  menu: {
    padding: 0,
  },
  mainContent: ({ assumedUser, showFooter, sidebarLayoutWidth = 0 }) => ({
    flexGrow: 1,
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    marginTop: assumedUser ? '30px' : 'unset',
    ...(sidebarLayoutWidth > 0 && {
      width: `calc(100% - ${sidebarLayoutWidth}px)`,
    }),
    [theme.breakpoints.only('xs')]: {
      marginTop: assumedUser ? '70px' : 'unset',
    },
    display: showFooter ? 'flex' : 'block',
    flexDirection: showFooter ? 'column' : 'unset',
    minHeight: showFooter ? '100vh' : 'unset',
  }),
  toolbarSpacing: {
    ...theme.mixins.toolbar,
    minHeight: '61px',
  },
  mobileMenuButton: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 24,
      width: 24,
      height: 24,
    },
  },
  mobileMenuButtonBadge: {
    right: '-2px',
  },
  unviewedLeadBadge: {
    backgroundColor: theme.palette.blue.main,
  },
  tabletMenuButton: {
    color: theme.palette.primary.main,
    width: collapsedDrawerWidth(theme),
    minWidth: collapsedDrawerWidth(theme),
    height: 48,
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
    borderRadius: 0,
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 24,
      width: 24,
      height: 24,
    },
  },
}))

export default useStyles
